<template>
  <BreadCrumbDetail :PageTitle="t('breadCrumb.users')" />
  <AllUsersContent1 />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import BreadCrumbDetail from "../../components/Common/BreadCrumbDetail.vue";
import AllUsersContent1 from "../../components/CRM/Leads/AllUsersContent.vue";


export default defineComponent({
  name: "AllUsersContent",
  components: {
    BreadCrumbDetail,
    AllUsersContent1,
  },
  setup() {
      const { t } = useI18n();
      return {
      t,
    };
    }
});
</script>